<script>
export default {
  name: 'icon-tick',
  props: {
    color: {
      default: () => {
        return 'white'
      },
      type: String,
    },
  },
}
</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="-3 -3 40 40">
    <rect id="長方形_960" data-name="長方形 960" width="40" height="40" fill="none" />
    <path id="Icon_awesome-check" data-name="Icon awesome-check"
      d="M5.658,16.756.244,11.342a.833.833,0,0,1,0-1.178L1.422,8.986a.833.833,0,0,1,1.178,0l3.647,3.647,7.812-7.812a.833.833,0,0,1,1.178,0L16.415,6a.833.833,0,0,1,0,1.178L6.836,16.756A.833.833,0,0,1,5.658,16.756Z"
      transform="translate(8.67 6.422)" fill="#00a5ee" />
  </svg>

</template>
